import { TRAINING_BASE_PATH } from '@/lib/training/basePath';

/** Product presentation only. Never use this selector for tenant identity or authorization. */
export const PRODUCT_BRAND_COOKIE = 'engageiq-product-brand';
export const PRODUCT_BRANDS = {
  engageiq: { id: 'engageiq', name: 'EngageIQ' },
  instructorone: { id: 'instructorone', name: 'InstructorOne' },
} as const;
export type ProductBrand = (typeof PRODUCT_BRANDS)[keyof typeof PRODUCT_BRANDS];

/** Exact allowlist: unknown, missing or tampered values always use EngageIQ. */
export function resolveProductBrand(value: string | null | undefined): ProductBrand {
  return value === 'instructorone' ? PRODUCT_BRANDS.instructorone : PRODUCT_BRANDS.engageiq;
}


/**
 * Where the brand logo / entry leads. InstructorOne's home is the training landing page (the same route the
 * training login returns to); EngageIQ keeps the calendar when signed in and the public home page otherwise.
 */
export function productBrandHomePath(brand: ProductBrand, signedIn: boolean): string {
  if (brand.id === 'instructorone') return TRAINING_BASE_PATH;
  return signedIn ? '/dashboard' : '/';
}

/** Entry link that selects a brand and lands on its home (used by the public home page). */
export function productBrandEntryHref(brand: ProductBrand): string {
  return `${productBrandHomePath(brand, true)}?brand=${brand.id}`;
}
